module.exports = __webpack_public_path__ + "static/img/networks_erc.2186ef5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/coin_dealer/networks_erc.png
// module id = /mnN
// module chunks = 0